// extracted by mini-css-extract-plugin
export default {"container":"SocialFollow_container__tr7D7","title":"SocialFollow_title__L5XZJ","socialIcons":"SocialFollow_socialIcons__fHe89","icon":"SocialFollow_icon__e4xKb"};